import { useCallback } from "react";
import { useRegisterTileUsage } from "./useRegisterTileUsage";
import {
	createUrlRelativeToEnvironment,
	navigateTo,
	navigateToUriInPopOutWindow
} from "client_legacy/ndaw/navigator";
import { TileRenderState } from "../RenderState/common";

export type TileNavigationOptions = {
	inNewWindow: false;
} | {
	inNewWindow: true;
	popOutWindow?: boolean;
};


export function useGo(
	renderStateIsh: Pick<TileRenderState, "data" | "dimension">
): ((options: TileNavigationOptions) => void) {
	const registerTileUsage: (() => void) = useRegisterTileUsage(renderStateIsh);

	const { data: tile } = renderStateIsh;

	return useCallback(
		(options: TileNavigationOptions): void => {
			registerTileUsage();

			const url: string = createUrlRelativeToEnvironment("/Workspace/Go/" + tile.id);

			if (options.inNewWindow) {
				if (options.popOutWindow) {
					navigateToUriInPopOutWindow(url);
				} else {
					navigateTo(url, true);
				}
			} else {
				navigateTo(url);
			}
		},
		[tile.id, registerTileUsage]
	);
};
